'use client';
import React from 'react';
import { VIEW_MORE_TEXT } from '@/constants/locale_text';
import { trackClick } from '@/lib/analytics';

interface ReadMoreProps {
  children: string;
  tenant: string;
  cutoff?: number;
}

const ReadMore: React.FC<ReadMoreProps> = ({
  children,
  tenant,
  cutoff = 120,
}) => {
  const [showFull, setShowFull] = React.useState(true); // Point 4: Show full text by default
  const summary = children || '';

  if (summary.length <= cutoff || showFull) {
    return <span className='text-sm font-medium text-gray-800'>{summary}</span>;
  }

  const showFullSummary = () => {
    setShowFull(true);
    trackClick('read_more_click', undefined, undefined, 'Read More Clicked');
  };

  // Find the last space before or at cutoff chars
  const cutoffIdx = summary.lastIndexOf(' ', cutoff);
  const shortSummary = summary.slice(0, cutoffIdx > 0 ? cutoffIdx : cutoff);

  return (
    <>
      <span className='text-gray-800'>{shortSummary}...</span>
      <button
        className='text-sm inline-block font-medium hover:underline ml-1'
        onClick={showFullSummary}
        type='button'
      >
        {VIEW_MORE_TEXT[tenant]}
      </button>
    </>
  );
};

export default ReadMore;
